/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsUnderutilizedCorestackProfilerResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsUnderutilizedCorestackProfilerResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsUnderutilizedCorestackProfilerResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsUnderutilizedCorestackProfilerResource>): RecommendationForFinopsUnderutilizedCorestackProfilerResource {
        let obj = Object.assign(new RecommendationForFinopsUnderutilizedCorestackProfilerResource(), model);
        RecommendationForFinopsUnderutilizedCorestackProfilerResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsUnderutilizedCorestackProfilerResource>): RecommendationForFinopsUnderutilizedCorestackProfilerResource {
        if (!model) return null;
        return RecommendationForFinopsUnderutilizedCorestackProfilerResource.newInstance(<RecommendationForFinopsUnderutilizedCorestackProfilerResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsUnderutilizedCorestackProfilerResource) {
        if (!obj) return;

        models.RecommendationForFinopsUnderutilizedCorestackProfilerResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsUnderutilizedCorestackProfilerResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsUnderutilizedCorestackProfilerResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
